import styled from 'styled-components'

export const AccountSidePanelContainer = styled.aside`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 300px;
  background-color: #ffffff;
  height: 30%;
  padding: 16px;
  border-radius: 16px;
  margin: 0;
`
